import { Quasar } from 'quasar'
import { boot } from 'quasar/wrappers'
import messages from 'src/i18n'
import { createI18n } from 'vue-i18n'

const datetimeFormats = {
  'en-US': {
    month: {
      month: 'long',
    },
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    shortMonth: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    YMD: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
  },
  'nl-NL': {
    month: {
      month: 'long',
    },
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    shortMonth: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    },
    YMD: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
}
const i18n = createI18n({
  datetimeFormats,
  legacy: false,
  locale: Quasar.lang.getLocale() === 'nl' ? 'nl-NL' : Quasar.lang.getLocale(),
  fallbackLocale: 'en-US',
  globalInjection: true,
  compositionOnly: true,
  useScope: 'global',
  messages,
})
export default boot(({ app }) => {
  app.use(i18n)
})

export { i18n }
